module.exports = __webpack_public_path__ + "img/review-expolre@2x.fabb1576.png";